import { TabsComponent } from "./tabs";

export const AppTabs = TabsComponent;
